@switch (workflowStatus) {
    @case (WorkflowStatusEnum.Completed) {
        <span>Completed {{ completionDate | timeAgo }} by {{ completedBy }}</span>
    }
    @case (WorkflowStatusEnum.Current) {
        <span>Started {{ startDate | timeAgo }} by {{ startedBy }}</span>
    }
}
